<template>
    <div class="scc-container__column alternate-registration-form">
        <article class="alternate-registration-form__right">
            <ContentBlock>
                <h2 class="alternate-registration-form__title">{{ title }}</h2>

                <ValidationObserver v-slot="{ handleSubmit }" slim>
                    <form :name="formName" class="track-form" novalidate @submit.prevent="handleSubmit(onSubmit)">
                        <template v-for="(block, index) in sortedBlocks">
                            <template v-if="block.blockType === 'name'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormName
                                    :key="index"
                                    v-model="form.name"
                                    is-showing-first-name
                                    is-requiring-first-name
                                    is-requiring-last-name
                                />
                            </template>

                            <template v-else-if="block.blockType === 'email'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormEmail :key="index" v-model="form.email" />
                            </template>

                            <template v-else-if="block.blockType === 'age'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormAge
                                    :key="index"
                                    v-model="form.birthday"
                                    label="Geboortedatum (dd-mm-jjjj)"
                                    required
                                />
                            </template>

                            <template v-else-if="block.blockType === 'tickets'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormTicketAmount :key="index" v-model="form.tickets" />
                            </template>

                            <template v-else-if="block.blockType === 'paymentMethod'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormPayment
                                    :key="index"
                                    v-model="form.paymentMethod"
                                    :options="currentPaymentMethods"
                                />
                            </template>

                            <template v-else-if="block.blockType === 'phone'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormPhone
                                    :key="index"
                                    v-model="form.phone"
                                    :isRequired="form.optInPhoneMarketing"
                                />
                            </template>

                            <!-- <template v-else-if="block.blockType === 'address'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormAddressWithZipCodeLookup
                                    :key="index"
                                    v-model="form.address"
                                    :gameId="game.id"
                                />
                            </template> -->

                            <template v-else-if="block.blockType === 'marketingOptIn'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormCheckbox
                                    :key="index"
                                    v-model="form.optInMarketing"
                                    name="optInMarketing"
                                    label="Ik wil graag op de hoogte wordenn gehouden"
                                />
                            </template>

                            <template v-else-if="block.blockType === 'emailOptIn'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormCheckbox
                                    :key="index"
                                    v-model="form.optInMarketing"
                                    name="optInMarketing"
                                    label="Ik wil graag op de hoogte wordenn gehouden"
                                />
                            </template>

                            <template v-else-if="block.blockType === 'phoneOptIn'">
                                <span
                                    v-if="block.title && block.title !== ''"
                                    :key="index + 't'"
                                    class="mb-1 alternate-registration-form__subtitle"
                                >
                                    {{ block.title }}
                                </span>
                                <AlternateFormCheckbox
                                    :key="index"
                                    v-model="form.optInMarketing"
                                    name="optInMarketing"
                                    label="Ik wil graag op de hoogte wordenn gehouden"
                                />
                            </template>
                        </template>

                        <AlternateFormCheckbox v-model="form.optInMarketing" name="optInMarketing" label="E-mail" />
                        <AlternateFormCheckbox v-model="form.optInSmsMarketing" name="optInSmsMarketing" label="SMS" />
                        <AlternateFormCheckbox
                            v-model="form.optInPhoneMarketing"
                            name="optInPhoneMarketing"
                            label="Telefoon"
                        />

                        <AlternateFormCheckbox
                            v-model="form.optInTerms"
                            name="optInTerms"
                            label="Ik ga akkoord met de spelregels en het privacybeleid."
                            :gameRulesLink="rulesLink"
                            :required="true"
                            class="mb-1"
                        />
                        <button
                            class="alternate-registration-form__button"
                            :class="loading ? 'alternate-registration-form__button--loading' : null"
                            type="submit"
                            :disabled="isDisabled"
                        >
                            <span class="alternate-registration-form__button-text">{{ buttonContent }}</span>
                            <ArrowRightIcon v-if="!loading" class="alternate-registration-form__button-icon" />
                            <div v-if="loading" class="alternate-registration-form__spinner"></div>
                        </button>
                    </form>
                </ValidationObserver>
            </ContentBlock>
        </article>
    </div>
</template>

<script>
// import './alternate-registration-form.scss';

import { ValidationObserver } from 'vee-validate';
import { sortBy } from 'lodash';

import { stripChars } from './../../utils/string';
import { fromStorage } from './../../utils/storage';
import ArrowRightIcon from '../../assets/icons/arrow-right';

import AlternateFormName from '../form/AlternateFormName';
import AlternateFormAge from '../form/AlternateFormAge';
import AlternateFormCheckbox from '../form/AlternateFormCheckbox';
import AlternateFormEmail from '../form/AlternateFormEmail';
import AlternateFormTicketAmount from '../form/AlternateFormTicketAmount';
import AlternateFormPayment from '../form/AlternateFormPayment';
import AlternateFormPhone from '../form/AlternateFormPhone';
// import AlternateFormAddressWithZipCodeLookup from '../form/AlternateFormAddressWithZipCodeLookup';

export default {
    name: 'RegistrationForm',
    components: {
        ValidationObserver,
        ArrowRightIcon,
        AlternateFormName,
        AlternateFormCheckbox,
        AlternateFormAge,
        AlternateFormEmail,
        AlternateFormTicketAmount,
        AlternateFormPayment,
        AlternateFormPhone,
        // AlternateFormAddressWithZipCodeLookup,
    },
    __editor: {
        requiredData: ['game', 'salesChannel', 'themeSettings'],
        hidden: ['onBehalfOf'],
        fields: {
            logo: {
                widget: 'text',
            },
            blocks: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        blockType: {
                            widget: 'select',
                            values: ['name', 'age', 'email', 'tickets', 'paymentMethod', 'phone'],
                        },
                    },
                },
            },
        },
    },
    props: {
        themeSettings: {
            type: Object,
        },
        title: {
            type: String,
            default: 'Loten kopen',
        },
        buttonText: {
            type: String,
            default: 'Afrekenen',
        },
        game: {
            type: Object,
            required: true,
        },
        salesChannel: {
            type: Object,
            required: true,
        },
        logo: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: 'Voor € 2,- per lot steun {{ name }} én maak je kans op te gekke prijzen.',
        },
        link: {
            type: String,
            default: '#prizes',
        },
        linkText: {
            type: String,
            default: 'Bekijk het prijzenpakket',
        },
        onBehalfOf: {
            type: String,
            default: 'current',
        },
        blocks: {
            type: Array,
            required: false,
            default: () => [
                {
                    title: '',
                    blockType: 'name',
                    position: 0,
                },
                {
                    title: '',
                    blockType: 'tickets',
                    position: 3,
                },
                {
                    title: '',
                    blockType: 'email',
                    position: 1,
                },
                {
                    title: undefined,
                    blockType: 'address',
                    position: 6,
                },
                {
                    title: undefined,
                    blockType: 'phone',
                    position: 5,
                },
                {
                    title: undefined,
                    blockType: 'age',
                    position: 2,
                },
                {
                    title: undefined,
                    blockType: 'paymentMethod',
                    position: 4,
                },
            ],
        },
    },
    data() {
        return {
            formName: 'loterij',
            ticketPrice: this.game.ticketPrice,
            submitted: false,
            loading: false,
            zipCodeLookup: true,
            form: {
                tickets: 2,
                subscriptionType: 'quarterly',
                gender: null,
                name: {
                    firstName: '',
                    lastNamePrefix: '',
                    lastName: '',
                },
                email: '',
                emailConfirm: '',
                phone: null,
                address: {
                    street: null,
                    houseNr: null,
                    houseNrAddition: null,
                    zipCode: null,
                    city: null,
                    country: null,
                },
                paymentMethod: undefined,
                birthday: null,
                optInTerms: false,
                optInMarketing: false,
                optInSmsMarketing: false,
                optInPhoneMarketing: false,
            },
        };
    },
    computed: {
        themeLogo() {
            return this.themeSettings?.logo;
        },
        rulesLink() {
            return window.location.origin + '/faq';
        },
        fullDescription() {
            return this.description.replace(/{{[^}]+}}/, this.game.name);
        },
        currentPaymentMethods() {
            return this.salesChannel?.paymentMethods.map(method => method.type) || [];
        },
        currentTotal() {
            return Number.isNaN(this.form.tickets)
                ? '€0.00'
                : (this.form.tickets * this.ticketPrice).toLocaleString('en-NL', {
                      style: 'currency',
                      currency: 'EUR',
                  });
        },
        buttonContent() {
            return this.isDisabled
                ? 'Er is geen betaalmethode gekozen!'
                : `${this.buttonText}${this.form.paymentMethod ? ' met ' + this.form.paymentMethod : ''} | ${
                      this.currentTotal
                  }`;
        },
        isDisabled() {
            return this.loading || (!this.isChanceGame() && this.currentPaymentMethods.length === 0);
        },
        redirectUrl() {
            let baseUrl = window.location.protocol + '//' + window.location.host + this.$router.options.base;
            let thanksPath = baseUrl.endsWith('/') ? 'bedankt' : '/bedankt';
            return baseUrl + thanksPath;
        },
        sortedBlocks() {
            const sortedBlocks = sortBy(this.blocks, block => block.position);
            // console.log(sortedBlocks);
            return sortedBlocks;
        },
    },
    methods: {
        createOrderError(err) {
            if (err.includes('not possible to issue tickets') || err.includes('not published'))
                this.$toast.error('Ah wat jammer! Je kunt op dit moment geen loten kopen.');
            else if (err.includes('tickets left')) this.$toast.error('Ongelooflijk, de loten zijn uitverkocht!');
            else
                this.$toast.error(
                    'Er is iets mis gegaan. Geen zorgen, er is nog niks van je rekening afschreven. Probeer het opnieuw.'
                );
        },
        formatCurrency(value) {
            if (['number', 'string'].includes(typeof value)) {
                let returnValue = parseFloat(value);
                returnValue = returnValue.toFixed(2);

                return returnValue.replace('.', ',');
            }
        },
        isChanceGame() {
            const whitelist = ['chance', 'small_chance', 'club_link'];
            return whitelist.includes(this.game.type);
        },
        onSubmit() {
            this.submitted = true;

            const {
                tickets,
                gender,
                name,
                email,
                phone,
                address,
                paymentMethod,
                cardNumber,
                birthday,
                optInTerms,
                optInMarketing,
            } = this.form;

            const customer = {
                gender,
                ...name,
                email,
                phone: stripChars(phone, '+-()'),
                ...address,
                cardNumber,
                birthday,
                optInAge: optInTerms, // Opt-in age is combined with opt-in terms
                optInTerms,
                optInMarketing,
            };

            const input = {
                customer,
                tickets,
                channel: process.env.GRIDSOME_CHANNEL,
                paymentMethod,
                redirectUrl: this.redirectUrl,
                reference: fromStorage('reference'),
                affiliateId: fromStorage('affiliate'),
            };

            if (paymentMethod === 'sepa') {
                if (process.env.VUE_APP_ENV === 'prod') {
                    let now = new Date();
                    input['mandateAcceptedDate'] = now.toISOString();
                }

                return this.createGameSubscription(input);
            }

            this.createOrder(input);
        },
        async createOrder(formInput) {
            this.loading = true;
            this.$api
                ?.createOrder(formInput, this.onBehalfOf)
                .then(response => {
                    if (response.paymentUrl) window.location = response.paymentUrl;
                })
                .catch(error => {
                    this.createOrderError(error);
                    this.loading = false;
                });
        },
        async createGameSubscription(formInput) {
            this.loading = true;
            await this.$api
                .createGameSubscription(formInput, this.onBehalfOf)
                .then(createGameSubscription => {
                    if (
                        createGameSubscription.gameSubscription.status !== 'active' &&
                        createGameSubscription.paymentUrl
                    ) {
                        window.location = createGameSubscription.paymentUrl;
                        return;
                    }

                    this.$router.push({
                        name: 'Page',
                        params: { path: 'bedankt' },
                        query: {
                            game_subscription_id: createGameSubscription.gameSubscription.id,
                        },
                    });
                })
                .catch(error => {
                    this.createOrderError(error);
                    this.loading = false;
                });
            this.loading = false;
        },
    },
};
</script>
